import React, {useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import PropTypes from "prop-types";
import ConfirmationButton from "../common/ConfirmationButton";
import {Button} from "@material-ui/core";

const ListItemMenu = ({itemId, onDeleteHandler, onEditHandler}) => {

  const [anchorEl, setAnchorEl] = useState(null);

  const onClose = () => {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <IconButton
        aria-label="More"
        aria-owns={open ? 'list-item-menu' : null}
        aria-haspopup="true"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        style={{width: 30, height: 30}}
      >
        <MoreVertIcon/>
      </IconButton>
      <Menu
        id="list-item-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null)
        }}

      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <ConfirmationButton
            size="small"
            variant="none"
            onConfirm={async () => {
              await onDeleteHandler(itemId);
              onClose();
            }}
            onCancel={onClose}
            confirmationTitle={"Usuwanie oferty"}
            confirmationText={"Czy na pewno chcesz usunąć ofertę? Operacja nieodwracalna!"}
            confirmLabel={'Potwierdzam'}
          >
            Usuń
          </ConfirmationButton>
          <Button
            onClick={onEditHandler}
            size="small"
            variant="none"
          >
            Edytuj
          </Button>
        </div>
      </Menu>
    </React.Fragment>
  )
}

ListItemMenu.propTypes = {
  itemId: PropTypes.string.isRequired,
  onDeleteHandler: PropTypes.func.isRequired,
  onEditHandler: PropTypes.func.isRequired,
};

export default ListItemMenu;
